import { connect } from 'react-redux';
import UpdateFolderTreeButton from '../../../../components/ParametersPage/ActionButtons/UpdateFolderTreeButton';
import { StoreState } from '../../../../reducers';

const mapStateToProps = (state: StoreState) => {
	const {
		driveList: {
			folderTreeUpdate: {
				isUpdating,
			},
		},
	} = state;

	return { isUpdatingFolderTree: isUpdating };
};

export default connect(mapStateToProps)(UpdateFolderTreeButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/ActionButtons/UpdateFolderTreeButton/index.tsx